 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import BACK_COVER_TEXT from '@/components/Back_Cover_Text'
 import DEAR_READER from '@/components/Dear_Reader'
 import EDITORS_NOTE from '@/components/Editors_Note'
 import DEDICATION from '@/components/Dedication'
 import CONTENTS from '@/components/Contents'
 import CHAPTER_ONE from '@/components/Chapter_One'
 import CHAPTER_TWO from '@/components/Chapter_Two'
 import CHAPTER_THREE from '@/components/Chapter_Three'
 import CHAPTER_FOUR from '@/components/Chapter_Four'
 import CHAPTER_FIVE from '@/components/Chapter_Five'
 import CHAPTER_SIX from '@/components/Chapter_Six'
 import CHAPTER_SEVEN from '@/components/Chapter_Seven'
 import CHAPTER_EIGHT from '@/components/Chapter_Eight'
 import EXCERPT from '@/components/Excerpt'
 import EXCERPTDOS from '@/components/Excerpt-Dos'
 import EXCERPTTRES from '@/components/Excerpt-Tres'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import ALSO_BY_AUTHOR from '@/components/Also_by_Author'
 import ABOUT_THE_AUTHOR from '@/components/About_the_Author'
 import ABOUT_THE_KOWALSKIS_SERIES from '@/components/About_The_Kowalskis_series'
 import ABOUT_THE_BOSTON_FIRE_ERIES from '@/components/About_the_Boston_Fire_eries'
 import MORE_FROM_CARINA from '@/components/More_from_Carina'
 import CARINA_BPA from '@/components/Carina_BPA'
 import WRITING_FOR_CARINA from '@/components/Writing_for_Carina'
 import COPYRIGHT from '@/components/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Chapter_One",
 			"name" : "Chapter_One",
 			"component" : CHAPTER_ONE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js